import $ from "cash-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { SplitText } from "gsapBonus";

export default (function () {
    /**
     * Initialize Slider instances
     */
    $(document).ready(function () {
        var $selector = $("[data-toggle-class]");
        var tweens = [];
        gsap.registerPlugin(ScrollTrigger);
        gsap.registerPlugin(SplitText);

        if ($selector.length) {
            if (log) console.log("%cfunction_scroll-toggle.js initialized", "color: green;");

            function init() {
                $selector.each(function () {
                    var $instance = $(this);
                    var $trigger = $instance.parents("[data-trigger]").length
                        ? $instance.parents("[data-trigger]")
                        : $instance;
                    var trigger = $trigger.attr("data-trigger");
                    var target = $instance[0];
                    var classList = $instance.attr("data-toggle-class");
                    var defaults = { start: "top bottom-=10%", end: "bottom top" };
                    var p = trigger ? JSON.parse(trigger) : defaults;
                    var once = false;

                    var toggleHandler = function (_self) {
                        $instance.toggleClass("on " + classList);
                        if (once) _self.kill();
                    };

                    var scrollTrigger = {
                        scroller: window,
                        trigger: $trigger[0],
                        endTrigger: "html",
                        start: p.start,
                        end: "bottom top",
                        onEnter: toggleHandler,
                        onLeaveBack: !once ? toggleHandler : null,
                    };

                    tweens.push(gsap.to(target, { scrollTrigger: scrollTrigger }));
                });
            }

            function clear() {
                tweens.forEach(function (_tween) {
                    _tween.invalidate();
                });
            }

            init();
            /*
            $(window).on("resizeEnd", function () {
                clear();
                init();
            });
            */
        }
    });
})();
